import React from 'react';

const AdminEmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  variant = 'default', // 'default', 'minimal', 'illustrated'
  className = ''
}) => {
  return (
    <div className={`admin-empty-state admin-empty-state-${variant} ${className}`}>
      {Icon && (
        <div className="admin-empty-state-icon">
          <Icon className="admin-empty-state-icon-svg" />
        </div>
      )}
      {title && <h3 className="admin-empty-state-title">{title}</h3>}
      {description && <p className="admin-empty-state-description">{description}</p>}
      {action && (
        <div className="admin-empty-state-action">
          {action}
        </div>
      )}
    </div>
  );
};

export default AdminEmptyState;

